import React from "react";
import ProjectCard from "../../Card/ProjectCard/ProjectCard";
import wave from "../../../icons/Wave.svg";
import { useStaticQuery, graphql } from "gatsby";
import "./ProjectSection.css";
import "twin.macro";

const Home = () => {
  const data = useStaticQuery(graphql`
    query MySecondQuery {
      allClientJson {
        nodes {
          title
          image {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `);

  return (
    <>
      <div className="card-div">
        <div tw="bg-gray-700 height[70px] w-full"> </div>
        <div
          tw="flex flex-col py-20 md:py-0 min-h-screen justify-center items-center  bg-no-repeat bg-cover space-y-10 bg-gray-700 text-white p-5"
          style={{ backgroundImage: `url(${wave})` }}
        >
          <center>
            <div class="main">
              <h1>Our Clients</h1>
              {data.allClientJson.nodes.map((item, index) => (
                <ProjectCard {...item} key={index} />
              ))}
            </div>
          </center>
        </div>
      </div>
    </>
  );
};

export default Home;
